import React from 'react';
import PropTypes from 'prop-types';

import './PageHeaderWrapper.css';

class PageHeader extends React.Component {
    render() {
        return (
            <div className="page-header-wrapper">
                <h1>{ this.props.text }</h1>
            </div>
        );
    }
}


PageHeader.propTypes = {
    text: PropTypes.string.isRequired
};

export default PageHeader;


// WEBPACK FOOTER //
// ./src/components/global/PageHeader/index.js